<div class="bg-m1 flex h-full cursor-default flex-col">
  <div
    class="flex h-2 flex-1 flex-row items-center justify-center overflow-y-auto"
  >
    <div class="flex w-96 flex-col items-center">
      <div>
        <m-completed-ring></m-completed-ring>
      </div>

      <div
        data-cy="userDeletedTitle"
        class="text-s2 mt-5 select-none text-2xl font-semibold"
        >{{ pageTitle }}</div
      >
      <div class="text-s1 mt-5 text-center">{{ email }}</div>

      <div class="text-s1 text-center"
        >To create new account, just click below.</div
      >

      <button
        data-cy="userDeletedCreateNewAccountButton"
        class="bg-m600 text-m0 mt-5 rounded px-5 py-3 font-medium focus:outline-none"
        (click)="createNewAccount()"
        >Create new account</button
      >
    </div>
  </div>
</div>
